import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { verifyToken } from '../store/slices/authSlice';

const AuthInitializer = () => {
	const dispatch = useAppDispatch();
	const { token, isAuthenticated } = useAppSelector((state) => state.auth);

	useEffect(() => {
		// Only verify token if we have one and we're not already authenticated
		if (token && !isAuthenticated) {
			console.log('AuthInitializer: Verifying token...');
			dispatch(verifyToken(token));
		}
	}, [dispatch, token, isAuthenticated]);

	return null; // This component doesn't render anything
};

export default AuthInitializer; 